/**
 * This file is intended to export suitable aliases for the type definitions in backend.ts.
 */

import { ZodError } from 'zod';
import {
  ArticleSearchResponseDtoAvailability,
  components,
  FormRequestDtoFormType,
  Container as RawContainer,
  Currency as RawCurrency,
  operations,
  Language as RawLanguage,
  CustomerOpenOrderResponseDtoOrderStatus,
} from './backend';

export type NormalizedErrorMessage =
  'generic_server_error' | 'not_in_stock' | 'out_of_stock' | 'required' | ZodError['issues'][0]['code'];

export const Language = RawLanguage;
export type Language = RawLanguage;

export type ArticleAvailability = ArticleSearchResponseDtoAvailability;

export const Currency = RawCurrency;
export type Currency = RawCurrency;

export const Container = RawContainer;
export type Container = RawContainer;

export type ArticleDetail = components['schemas']['ArticleDetailResponseDto'];
export type ArticleSearch = components['schemas']['ArticleSearchResponseDto'];
export type DownloadSection = components['schemas']['DownloadSectionResponseDto'];
export type CuringCondition = components['schemas']['CuringConditionResponseDto'];

export type GetFilterReferencesResponse =
  operations['ArticleController_getFilterReferenceData']['responses']['200']['content']['application/json'];
export type GetArticlesResponse =
  operations['ArticleController_getArticles']['responses']['200']['content']['application/json'];
export type GetArticleDetailResponse =
  operations['ArticleController_getArticleDetail']['responses']['200']['content']['application/json'];
export type GetArticlesBatchResponse =
  operations['ArticleController_getArticlesBatch']['responses']['200']['content']['application/json'];
export type GetSeriesResponse =
  operations['SeriesController_getSeries']['responses']['200']['content']['application/json'];

export type SetLanguageResponse = operations['UserController_setUserLanguage']['responses']['204']['content'];
export type LanguageRequestBody = components['schemas']['LanguageRequestDto'];

// ORDER
// operations
export type GetArticleAvailabilityResponse =
  operations['OrderController_getArticleAvailability']['responses']['200']['content']['application/json'];
export type GetArticleDetailPreCartResponse =
  operations['OrderController_getArticleDetailPreCart']['responses']['200']['content']['application/json'];
export type PlaceOrderRequestBody =
  operations['OrderController_placeOrder']['requestBody']['content']['application/json'];
export type PlaceOrderResponse = operations['OrderController_placeOrder']['responses']['204']['content'];

// CART
// schemas
export type Cart = components['schemas']['CartResponseDto'];
export type CartItem = components['schemas']['ItemResponseDto'];
// operations
export type PutArticleInCartRequestBody =
  operations['CartController_putArticleInCart']['requestBody']['content']['application/json'];
export type PutArticleInCartResponse =
  operations['CartController_putArticleInCart']['responses']['200']['content']['application/json'];
export type GetCartResponse =
  operations['CartController_getCurrentCart']['responses']['200']['content']['application/json'];

// USER-MANAGEMENT
// schemas
export type GetUsersResponseDto = components['schemas']['AuthUserResponseDto'];

// operations
export type GetUsersResponse = operations['UserController_getUsers']['responses']['200']['content']['application/json'];
export type GetSelfUserResponse =
  operations['UserController_getSelf']['responses']['200']['content']['application/json'];

// USER-REQUEST-FORMS
// enums
export const FormType = FormRequestDtoFormType;
export type FormType = FormRequestDtoFormType;

// schemas
export type FormFieldResponseDtoUnion = components['schemas']['FormResponseDto']['fields'][0];
export type FormRequestBody = components['schemas']['FormRequestDto'];

// operations
export type AnonymousFormSendResponse = operations['FormController_sendAnonymousMail']['responses']['204']['content'];
export type AuthenticatedFormSendResponse = operations['FormController_sendMail']['responses']['204']['content'];

export type GetAnonymousCreateNewUserForExistingCustomerResponse =
  operations['FormController_getAnonymousCreateNewUserForExistingCustomer']['responses']['200']['content']['application/json'];
export type GetAnonymousCreateNewUserForNewCustomerResponse =
  operations['FormController_getAnonymousCreateNewUserForNewCustomer']['responses']['200']['content']['application/json'];

export type GetArticleNotFoundResponse =
  operations['FormController_getArticleNotFound']['responses']['200']['content']['application/json'];
export type GetAddressMutationResponse =
  operations['FormController_getAddressMutation']['responses']['200']['content']['application/json'];
export type GetInquiryAboutArticleResponse =
  operations['FormController_getInquiryAboutArticle']['responses']['200']['content']['application/json'];
export type GetOrderSampleSheetResponse =
  operations['FormController_getOrderSampleSheet']['responses']['200']['content']['application/json'];
export type GetDeleteUserResponse =
  operations['FormController_getCreateDeleteUserAccount']['responses']['200']['content']['application/json'];
export type GetNewDeliveryAddressResponse =
  operations['FormController_getCreateNewDeliveryAddressForExistingCustomer']['responses']['200']['content']['application/json'];
export type GetCreateNewUserForExistingCustomerResponse =
  operations['FormController_getCreateNewUserForExistingCustomer']['responses']['200']['content']['application/json'];
export type GetServiceRequestResponse =
  operations['FormController_getServiceRequest']['responses']['200']['content']['application/json'];

export type GetRecentArticlesResponse =
  operations['CustomerController_getRecentArticles']['responses']['200']['content']['application/json'];

export type GetOpenOrdersResponse =
  operations['CustomerController_getOpenOrders']['responses']['200']['content']['application/json'];
export type OpenOrderDto = components['schemas']['CustomerOpenOrderResponseDto'];
export const OrderStatus = CustomerOpenOrderResponseDtoOrderStatus;
export type OrderStatus = CustomerOpenOrderResponseDtoOrderStatus;

export type GetCustomerResponse =
  operations['CustomerController_getCustomerDetail']['responses']['200']['content']['application/json'];
export type CustomerShippingAddress = components['schemas']['CustomerShippingAddressResponseDto'];
export type CustomerAddress = components['schemas']['CustomerAddressResponseDto'] | CustomerShippingAddress;
